module.exports = __webpack_public_path__ + "img/xl_nx.2bb18e45.png";